import { lazyNamed } from 'src/utils/lazyNamed.ts';
import { KbTab } from './types.ts';

export { KbTab };

// The admin surface for the base the ZZupport chat answers from: two tabs behind
// `Layout`, which also carries the header that writes a section into it.
const KnowledgeBase = {
  Layout: lazyNamed(() => import('./Layout.tsx'), 'Layout'),
  Summary: lazyNamed(() => import('./Summary/index.tsx'), 'Summary'),
  Gaps: lazyNamed(() => import('./Gaps/index.tsx'), 'Gaps'),
};

export default KnowledgeBase;
